<template>
  <div class="overlay" :class="{ light, white: isFirstLoading }"></div>
</template>

<script>
import { isFirstLoading } from '../helpers/loading.js';

export default {
  name: 'Overlay',
  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      isFirstLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: #00000066;
  overflow: hidden;
  z-index: 9999;

  &.light {
    background: #ffffff40;
  }

  &.white {
    background: #ffffffff;
  }
}
</style>
